<template>
  <div class="contents-inner">
    <p class="hd-type-0n3">
      <span>事業内容</span>
    </p>
    <p
      class="mt20 pega-pre-wrap"
      data-test="businessContent"
      v-text="companyInfo.businessContent"
    />
    <div
      v-show="isMoreShow"
      data-test="other-content"
      class="mt20"
    >
      <template v-if="companyInfo.established">
        <p
          class="hd-type-0n3"
          data-test="established-title"
        >
          <span>設立</span>
        </p>
        <p
          class="mt20"
          data-test="established"
        >
          {{ companyInfo.established }}
        </p>
      </template>

      <template v-if="companyInfo.capital">
        <p
          class="hd-type-0n3"
          data-test="capital-title"
        >
          <span>資本金</span>
        </p>
        <p
          class="mt20"
          data-test="capital"
        >
          {{ companyInfo.capital }}
        </p>
      </template>

      <template v-if="companyInfo.sale">
        <p
          class="hd-type-0n3"
          data-test="sale-title"
        >
          <span>売上高</span>
        </p>
        <p
          class="mt20"
          data-test="sale"
        >
          {{ companyInfo.sale }}
        </p>
      </template>

      <template v-if="isShow.employee">
        <p
          class="hd-type-0n3"
          data-test="employeeNumber-title"
        >
          <span>従業員数</span>
        </p>
        <p
          v-if="companyInfo.employeeNumber"
          class="mt20"
          data-test="employeeNumber"
        >
          {{ companyInfo.employeeNumber }}
        </p>
        <dl
          v-if="companyInfo.averageAge"
          class="bg-blue-box mt15"
          data-test="averageAge"
        >
          <dt>平均年齢</dt>
          <dd>{{ companyInfo.averageAge }}</dd>
        </dl>
        <dl
          v-if="companyInfo.midCareerPercentage"
          class="bg-blue-box mt10"
          data-test="midCareerPercentage"
        >
          <dt>中途入社の割合</dt>
          <dd>{{ companyInfo.midCareerPercentage }}</dd>
        </dl>
      </template>

      <template v-if="isShow.representative">
        <p
          class="hd-type-0n3"
          data-test="representative-title"
        >
          <span>代表者</span>
        </p>
        <p
          v-if="companyInfo.representative"
          class="mt20"
          data-test="representative"
        >
          {{ companyInfo.representative }}
        </p>
        <dl
          v-if="companyInfo.representativeProfile"
          class="bg-blue-box mt15"
          data-test="representativeProfile"
        >
          <dt>代表者略歴</dt>
          <dd
            class="pega-pre-wrap"
            v-text="companyInfo.representativeProfile"
          />
        </dl>
      </template>

      <template v-if="companyInfo.note">
        <p
          class="hd-type-0n3"
          data-test="note-title"
        >
          <span>備考</span>
        </p>
        <p
          class="mt20 pega-pre-wrap"
          data-test="note"
          v-text="companyInfo.note"
        />
      </template>

      <template v-if="companyInfo.hp">
        <p
          class="hd-type-0n3"
          data-test="hp-title"
        >
          <span>企業HP</span>
        </p>
        <p
          class="mt20"
          data-test="hp"
        >
          <a
            :href="companyInfo.hp"
            target="_blank"
            rel="nofollow"
          >{{ companyInfo.hp }}</a>
        </p>
      </template>
    </div>
    <div
      v-if="isShowAccordion"
      id="accordion-switch"
      data-test="more-show-div"
    >
      <span
        data-test="more-show-span"
        :style="`background-image: url(${userCommonImageUrlForSp}/${moreShowIconName}); background-repeat: no-repeat; background-position: left; background-size: 8px 8px;`"
        @click="isMoreShow = !isMoreShow"
      >
        {{ isMoreShow ? '閉じる' : '会社概要をもっと見る' }}
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/company/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
export default {
  mixins: [jobPreviewCommon],
  props: {
    companyInfo: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isMoreShow: false
    }
  },
  computed: {
    moreShowIconName () {
      return this.isMoreShow ? 'icon_arrow_up_red.png' : 'icon_arrow_down_red.png'
    },
    isShowAccordion () {
      return this.companyInfo.established || this.companyInfo.capital ||
      this.companyInfo.sale || this.companyInfo.employeeNumber ||
      this.companyInfo.averageAge || this.companyInfo.midCareerPercentage ||
      this.companyInfo.representative || this.companyInfo.representativeProfile ||
      this.companyInfo.note || this.companyInfo.hp
    }
  }
}
</script>
